module.exports = __webpack_public_path__ + "static/media/hover-instagram.0f694a94.svg";